import { Pipe, PipeTransform } from '@angular/core';
import { constants } from '@app/shared/utils/constants';

@Pipe({
  name: 'ticketLogType',
  standalone: false,
})
export class TicketLogTypePipe implements PipeTransform {
  transform(value?: string, args?: any): string | null {
    if (!value) {
      return null;
    }

    return constants.ticketcenter.ticketLogTypes.find(tlt => tlt.value === value).label;
  }
}
